/* NW Wellness — compass motion layer.
   Adds .nw-motion to <html> only when the visitor allows motion, then
   reveals eyebrow rules as they scroll into view. Everything degrades
   to fully static without JS or with prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('nw-motion');

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.eyebrow').forEach(function (el) {
      el.classList.add('is-inview');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  document.querySelectorAll('.eyebrow').forEach(function (el) {
    io.observe(el);
  });
})();

